import { ChevronRight, Folder, FolderOpen } from "lucide-react";
import { useFolders } from "@/hooks/folders";
import { cn } from "@/lib/utils";

interface FolderNavigationProps {
  selectedFolderId?: string | null;
  onFolderSelect?: (folderId: string | null | undefined) => void;
  className?: string;
}

export const FolderNavigation = ({ selectedFolderId, onFolderSelect, className }: FolderNavigationProps) => {
  const { folders } = useFolders();

  const selectedFolder = selectedFolderId ? folders.find((f) => f.id === selectedFolderId) : null;

  const getBreadcrumbs = () => {
    if (selectedFolderId === undefined) {
      return [{ label: "All Documents", id: undefined }];
    }

    if (selectedFolderId === null) {
      return [
        { label: "All Documents", id: undefined },
        { label: "Uncategorized", id: null },
      ];
    }

    if (selectedFolder) {
      return [
        { label: "All Documents", id: undefined },
        { label: selectedFolder.name, id: selectedFolder.id, color: selectedFolder.color },
      ];
    }

    return [{ label: "All Documents", id: undefined }];
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className={cn("flex items-center gap-2 text-sm", className)}>
      {breadcrumbs.map((crumb, index) => (
        <div key={index} className="flex items-center gap-2">
          {index > 0 && <ChevronRight className="h-4 w-4 text-gray-400" />}
          <button
            onClick={() => onFolderSelect?.(crumb.id)}
            className={cn(
              "flex items-center gap-1.5 px-2 py-1 rounded-md transition-colors",
              index === breadcrumbs.length - 1
                ? "text-genie-primary font-medium bg-genie-primary/5"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            )}
          >
            {crumb.id === undefined ? (
              <FolderOpen className="h-4 w-4" />
            ) : crumb.id === null ? (
              <Folder className="h-4 w-4" />
            ) : (
              <Folder className="h-4 w-4" style={{ color: crumb.color || "#3B82F6" }} />
            )}
            <span>{crumb.label}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

